import { credentials } from '@shootsta/client-auth';

const isAnonymousUser = () => {
  const { user: { isAnonymous = false } = {} } = {
    user: { isAnonymous: true },
    ...credentials.get()
  };

  return Boolean(isAnonymous);
};

export default isAnonymousUser;